// Body load opacity
$(window).on("load",(function(){ 
    $("body").animate({opacity:1},500)  

$(".homerich-text").addClass('text-fade-load');
  setTimeout(function(){
  // $(".about_info").addClass('text-fade-load');
     $('.about_info').animate({ 'opacity': '1' }, 1000);
     }, 1000);
   
$('.text-fade').each(function (i) {
      var bottom_of_object = $(this).offset().top + $(this).outerHeight();
      var bottom_of_window = $(window).scrollTop() + $(window).height() + 900;      
      /* If the object is completely visible in the window, fade it in */
      if (bottom_of_window > bottom_of_object) {
        $(this).animate({ 'opacity': '1' }, 1000);
        /* 1500 is the duration of fade effect */       
      }
    }); 
}));




$(window).on("load resize",function(){
  setTimeout(function(){
	var boxheight = $('.multicolumn_wrapper').height();
	$(".multi-item").css('height', boxheight);
    

var colheight = $('#product-grid li:nth-child(1) .pro_text').height();
    if ($(window).width() < 767) {
	$(".card__media .media, .card__inner").css('min-height', colheight + 160);
    } else {
      $(".card__media .media, .card__inner").css('min-height', colheight + 170);
    }
      
  }, 200);
});



$(document).ready(function () {
$('.footer-block__details-content li:first-child a').attr('target', '_blank');  
     $('.announcement-slider').slick({
        dots: true,
        infinite: true,
           arrows: false,
        speed: 500,
        adaptiveHeight: true,
        fade: true,
        slidesToShow: 1,
        slidesToScroll: 1
    }); 
  $('.multicolumn_slider').slick({
        dots: false,
        infinite: true,
        arrows: true,
        speed: 500,
        fade: false,
    centerMode: true,
                centerPadding: '0px',
        slidesToShow: 3,
        slidesToScroll: 1,
     responsive: [
       {
            breakpoint: 767,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        }]
    });

$(".footer-block__details-content li:nth-child(2) a").attr('target', '_blank');
 
  
});

// FADE IFFECT
/* Every time the window is scrolled ... */
  $(window).scroll(function () {    
    /* Check the location of each desired element */
    $('.text-fade').each(function (i) {
      var bottom_of_object = $(this).offset().top + $(this).outerHeight();
      var bottom_of_window = $(window).scrollTop() + $(window).height() + 700;      
      /* If the object is completely visible in the window, fade it in */
      if (bottom_of_window > bottom_of_object) {
        $(this).animate({ 'opacity': '1' }, 1000);
        /* 1500 is the duration of fade effect */       
      }
    });   


    $('.text-fade-scroll').each(function (i) {
      var bottom_of_objects = $(this).offset().top + $(this).outerHeight();
      var bottom_of_windows = $(window).scrollTop() + $(window).height() + 1100;      
      /* If the object is completely visible in the window, fade it in */
      if (bottom_of_windows > bottom_of_objects) {
        $(this).animate({ 'opacity': '1' }, 500);
        /* 1500 is the duration of fade effect */       
      }
    });  
  });



setTimeout(function(){
$('#newcontact_form select').each(function () {


   
    // Cache the number of options
    var $this = $(this),
        numberOfOptions = $(this).children('option').length;

    // Hides the select element
    $this.addClass('s-hidden');

    // Wrap the select element in a div
    $this.wrap('<div class="select"></div>');

    // Insert a styled div to sit over the top of the hidden select element
    $this.after('<div class="styledSelect"></div>');

    // Cache the styled div
    var $styledSelect = $this.next('div.styledSelect');

    // Show the first select option in the styled div
    $styledSelect.text($this.children('option').eq(0).text());

    // Insert an unordered list after the styled div and also cache the list
    var $list = $('<ul />', {
        'class': 'options'
    }).insertAfter($styledSelect);

    // Insert a list item into the unordered list for each select option
    for (var i = 0; i < numberOfOptions; i++) {
        $('<li />', {
            text: $this.children('option').eq(i).text(),
            rel: $this.children('option').eq(i).val()
        }).appendTo($list);
    }

    // Cache the list items
    var $listItems = $list.children('li');

    // Show the unordered list when the styled div is clicked (also hides it if the div is clicked again)
    $styledSelect.click(function (e) {
        e.stopPropagation();
        $('div.styledSelect.active').each(function () {
            $(this).removeClass('active').next('ul.options').hide();
        });
        $(this).toggleClass('active').next('ul.options').toggle();
    });

    // Hides the unordered list when a list item is clicked and updates the styled div to show the selected list item
    // Updates the select element to have the value of the equivalent option
    $listItems.click(function (e) {
        e.stopPropagation();
        $styledSelect.text($(this).text()).removeClass('active');
        $this.val($(this).attr('rel'));
        $list.hide();
          $('.options li').not(this).removeClass('active')
        $(this).addClass('active');
       $styledSelect.addClass('textactive');
        /* alert($this.val()); Uncomment this for demonstration! */
    });

    // Hides the unordered list when clicking outside of it
    $(document).click(function () {
        $styledSelect.removeClass('active');
      // $styledSelect.removeClass('textactive');
        $list.hide();
    });
 
});
  }, 200);